var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linecap: square;\n      }\n\n      .cls-3 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Email Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.85,20.05a8.48,8.48,0,0,0,.1-1.14,10.63,10.63,0,0,0-.05-1.14l2.51-1.89a.58.58,0,0,0,.15-.74L41.31,11a.57.57,0,0,0-.71-.27l-2.93,1.12a8.7,8.7,0,0,0-2-1.19l-.37-3.11a.59.59,0,0,0-.58-.5L30.09,7a.58.58,0,0,0-.59.48L29,10.56a8.31,8.31,0,0,0-2,1.11l-2.89-1.24a.59.59,0,0,0-.72.24l-2.42,4a.59.59,0,0,0,.12.75l2.43,2a8.48,8.48,0,0,0-.1,1.14,8.62,8.62,0,0,0,0,1.14L21,21.57a.59.59,0,0,0-.16.75l2.26,4.1a.58.58,0,0,0,.7.27l2.94-1.12a8.77,8.77,0,0,0,1.95,1.19L29,29.87a.57.57,0,0,0,.57.5l4.67.1a.59.59,0,0,0,.59-.48l.5-3.09a8.31,8.31,0,0,0,2-1.11L40.26,27a.59.59,0,0,0,.72-.24l2.42-4a.61.61,0,0,0-.12-.76ZM32.1,22.82a4.09,4.09,0,1,1,4.18-4A4.1,4.1,0,0,1,32.1,22.82Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "19.85 26.84 9.93 26.84 9.93 52.99 54.11 52.99 54.11 26.84 45.09 26.84"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "9.93 26.84 31.57 38.56 54.11 26.84"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 53.54,
    y1: 52.54,
    x2: 35.35,
    y2: 36.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.27,
    y1: 52.54,
    x2: 24.69,
    y2: 37.21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSettings01);
export default __webpack_public_path__ + "static/media/Email_Settings_01.35fc25a68be89658d48d3c997ed9a647.svg";
export { ForwardRef as ReactComponent };